<template>
  <div class="modal" v-if="forceReload">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">EDIT IUJP</h4>
          <button type="button" class="btn btn-sm" v-on:click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="kbli-modal-filter-search" style="padding: 0 10px">
          <form v-on:submit.prevent="noop">
            <div class="input-search">
              <b-input-group>
                <template #append>
                  <b-input-group-text>
                    <strong>
                      <i class="fas fa-times" style="cursor:pointer; marginRight: 10px" @click="resetPlaceholder()"
                        v-if="subSearch.length !== '' && subSearch"></i>
                      <i class="fas fa-search" style="cursor:pointer"></i>
                    </strong>
                  </b-input-group-text>
                </template>
                <b-form-input type="text" placeholder="Cari IUJP" v-model="subSearch"
                  @keyup="searchRun()"></b-form-input>
              </b-input-group>
            </div>
          </form>
        </div>
        <div class="modal-body" v-if="iujpData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column10">Jenis</div>
            <div class="column30 mr10">Bidang</div>
            <div class="column50 mr10">Sub Bidang</div>
          </div>
          <div class="horizontal" v-for="(item, index) in iujp" :key="index">
            <div class="column5">
              <input class="modal-input-checkbox" type="checkbox" :id="index" :value="item.id" v-model="choose" />
            </div>
            <div class="column10">{{ item.jenis }}</div>
            <div class="column30 mr10">{{ item.bidang }}</div>
            <div class="column50 mr10">{{ item.sub_bidang }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="submit()">
            Selesai
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      iujp: [],
      choosedIujp: [],
      subData: [],
      subSearch: '',
      forceReload: true,
    }
  },
  computed: {
    choose: {
      get: function () {
        return this.choosedIujp
      },
      set: function (newValue) {
        let newItem = ''
        let newChoose = []
        if (newValue) {
          newChoose = newValue
          newItem = newChoose.filter(i => !this.choosedIujp.includes(i))
        }
        let createdItem = this.iujp.filter(i => i.id == newItem)
        if (
          newChoose.length > this.choosedIujp.length &&
          newChoose.length - this.choosedIujp.length == 1
        ) {
          if (
            confirm(
              `Ingin menambahkan ${createdItem[0].jenis}-${createdItem[0].sub_bidang}?`
            )
          ) {
            this.choosedIujp = newChoose
            this.$store.dispatch('addEdit/addItemIujp', {
              vendor_id: this.$get(this.$store, 'state.level1.vendorId'),
              iujpData: createdItem[0],
              onSuccess: async () => {
                await this.$store.commit('level1/INFO_CALLBACK', {
                  tab: 'informasi',
                  updateInfoSuccess: async () => {
                    await this.changeIujpDefault()
                  },
                })
                // await this.resetPlaceholder()
                // await this.setUpData()
              },
            })
          } else {
            let newList = newChoose.filter(i => !newItem.includes(i))
            this.choosedIujp = newList

            this.forceReload = false
            this.$nextTick(() => {
              this.forceReload = true
            })
          }
        }
        if (
          this.choosedIujp.length > newChoose.length &&
          this.choosedIujp.length - newChoose.length == 1
        ) {
          let delItem = this.choosedIujp.filter(i => !newChoose.includes(i))
          let deletedItem = this.iujp.filter(i => i.id == delItem[0])
          if (
            confirm(
              `Ingin menghapus ${deletedItem[0].jenis}-${deletedItem[0].sub_bidang}?`
            )
          ) {
            this.$store.dispatch('addEdit/deleteIujp', {
              iujp_id: deletedItem[0].id_iujp_vendor,
              onSuccess: async () => {
                await this.$store.commit('level1/INFO_CALLBACK', {
                  tab: 'informasi',
                  updateInfoSuccess: async () => {
                    await this.changeIujpDefault()
                  },
                })
                // await this.setUpData()
              },
            })
          } else {
            this.forceReload = false
            this.$nextTick(() => {
              this.forceReload = true
            })
          }
        }
      },
    },
    iujpData: async function () {
      return this.setUpData()
    },
  },
  methods: {
    async searchRun(id) {
      const search = String(this.subSearch)
      const list = this.subData

      let filteredList = []
      for (let i in list) {
        if (
          list[i].sub_bidang.toLowerCase().indexOf(search.toLowerCase()) != -1
        ) {
          filteredList.push(list[i])
        }
      }

      this.iujp = filteredList
    },
    resetPlaceholder() {
      this.subSearch = ''
      this.iujp = this.subData
    },
    async submit() {
      this.closeModal()
    },
    async setUpData() {
      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      const getIujp = await this.$getIujp()
      const defaultIujp = await this.$store.state.addEdit.choosedIujp

      let reduceIujp = await getIujp.reduce((a, b) => ({ ...a, [b.id]: b }), {})

      let reduceDefault =
        (await defaultIujp) &&
        defaultIujp.reduce((a, b) => ({ ...a, [b.id]: b }), {})

      let combine = { ...reduceIujp, ...reduceDefault }

      let newKbli = await Object.values(combine)

      this.iujp = await newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.subData = newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.choosedIujp = await defaultIujp.map(list => {
        return list.id
      })

      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
    },
    changeIujpDefault() {
      const info = this.$store.state.level1.information
      let storeIujp = []
      if (info.iujp && info.iujp.length > 0) {
        for (let i in info.iujp) {
          let newIujp = info.iujp[i].master_iujp
          newIujp['checked'] = true
          newIujp['id_iujp_vendor'] = info.iujp[i].id
          storeIujp.push(newIujp)
        }
      }
      this.$store.commit('addEdit/SET_STATE_DATA', {
        name: 'choosedIujp',
        value: storeIujp,
      })
      this.choosedIujp = storeIujp.map(list => {
        return list.id
      })
    },
    closeModal() {
      this.$store.commit('modalStore/SET_IUJP_MODAL', false)
    },
  },
}
</script>
<style scoped>
.modal {
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-dialog {
  width: 100vw;
  background-color: green;
}

.modal-content {
  width: 90vw;
  position: absolute;
  transform: translateX(-30%);
}

.modal-body {
  height: 50vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
